import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../contexts/LanguageContext';
const PHOTO_ENGAGEMENT = 'https://cdn.magicpatterns.com/uploads/78oUjoohVDZMSVNntfGZAT/Placeholder_Image_(2).png';
const PHOTO_PORTRAIT = 'https://cdn.magicpatterns.com/uploads/bzoVm2uy1exj5uYbdruWtS/Placeholder_Image.png';
const PHOTO_DUO = 'https://cdn.magicpatterns.com/uploads/7CZNZfeY13hQmEeGymLnBN/Placeholder_Image_(1).png';
const HIGHLIGHT_STYLE: React.CSSProperties = {
  backgroundImage: 'linear-gradient(90deg, rgba(248,164,0,0.26) 0%, rgba(248,164,0,0.18) 60%, rgba(248,164,0,0.06) 100%)',
  backgroundSize: '100% 80%',
  backgroundPosition: 'center 65%',
  backgroundRepeat: 'no-repeat'
};

/** Les images fournies contiennent une marge blanche : on zoome pour ne garder que la photo */
const PHOTO_CLASS = 'absolute inset-0 h-full w-full scale-[1.34] object-cover transition-transform duration-500 group-hover:scale-[1.4]';
const CARD_HOVER = 'transition-all duration-300 hover:-translate-y-1.5 hover:shadow-[0_26px_60px_rgba(8,8,82,0.18)]';
export function Results() {
  const {
    t
  } = useLanguage();
  const r = t.results;
  return <section id="resultats" aria-labelledby="results-title" className="scroll-mt-0 px-5 pb-20 sm:px-6 sm:pb-24 lg:pb-28" data-id="element-156" data-mp="1r48fdwz697ow">
      <div className="mx-auto max-w-[1060px]" data-id="element-157" data-mp="210v2ksez0au3">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.5
      }} transition={{
        duration: 0.5,
        ease: [0.22, 1, 0.36, 1]
      }} data-id="element-158" data-mp="211mxe10qu4jb">
          <span className="inline-block rounded-md border border-[rgba(248,164,0,0.45)] px-2.5 py-1 text-[11px] font-medium uppercase tracking-[0.08em] text-blue-reways-950-lock" data-id="element-159" data-mp="2es04k15t9f7l">
            {r.eyebrow}
          </span>
          <div className="mt-4 grid gap-6 lg:grid-cols-[1.25fr_1fr] lg:items-center lg:gap-12" data-id="element-160" data-mp="2oqpcp27wnlan">
            <h2 id="results-title" className="font-hero text-[30px] font-medium leading-[1.2] text-blue-reways-950-lock sm:text-[38px]" data-id="element-161" data-mp="2sqq1ngsmrevy">
              {r.titleBefore}{' '}
              <span className="box-decoration-clone px-1 text-[#F2A007]" style={HIGHLIGHT_STYLE} data-id="element-162" data-mp="oopriyua3jvt">
                {r.highlight}
              </span>{' '}
              <br className="hidden sm:block" data-id="element-163" data-mp="xocu3nyquvqg" />
              {r.titleAfter}
            </h2>
            <p className="max-w-[300px] text-[14px] leading-[1.7] text-grey-800-lock" data-id="element-164" data-mp="xmi7m57tqvk9">{r.intro}</p>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.2
      }} transition={{
        duration: 0.55,
        delay: 0.1,
        ease: [0.22, 1, 0.36, 1]
      }} className="mt-12 grid gap-5 sm:grid-cols-2 lg:mt-16 lg:grid-cols-3 lg:items-stretch" data-id="element-165" data-mp="17exr56yrrs79">
          {/* Engagement */}
          <article className={`group flex h-full flex-col gap-7 rounded-[14px] bg-[#FFC163] p-2.5 shadow-[0_18px_45px_rgba(8,8,82,0.10)] ${CARD_HOVER}`} data-id="element-166" data-mp="3j3oz8txngsdo">
            <div className="relative isolate aspect-[4/5] overflow-hidden rounded-[10px] lg:aspect-auto lg:min-h-[340px] lg:flex-1" data-id="element-167" data-mp="391v1uv8lnb6v">
              <img src={PHOTO_ENGAGEMENT} alt={r.engagementAlt} loading="lazy" className={PHOTO_CLASS} data-id="element-168" data-mp="2za77omknrg1p" />
            </div>
            <div className="px-4 pb-4" data-id="element-169" data-mp="34808t173tjv4">
              <p className="font-hero text-[56px] font-semibold leading-none tracking-[-0.02em] text-blue-reways-950-lock sm:text-[60px]" data-id="element-170" data-mp="346xjuytcdrhu">
                +49 %
              </p>
              <p className="mt-4 font-hero text-[19px] font-medium text-blue-reways-950-lock" data-id="element-171" data-mp="2ucfe7o4d7lve">{r.engagementLabel}</p>
              <p className="mt-4 text-[11px] leading-[1.5] text-[rgba(8,8,82,0.7)]" data-id="element-172" data-mp="2gd5y0og5srrf">{r.engagementSource}</p>
            </div>
          </article>

          {/* Temps gagné + portrait */}
          <div className="flex h-full flex-col gap-5" data-id="element-173" data-mp="ek9gcirquqyc">
            <article className={`relative overflow-hidden rounded-[14px] bg-blue-reways-950-lock p-6 shadow-[0_18px_45px_rgba(8,8,82,0.22)] sm:p-7 ${CARD_HOVER}`} data-id="element-174" data-mp="jjchvt8imf1k">
              <span aria-hidden="true" className="pointer-events-none absolute -bottom-20 -right-16 h-56 w-56 rounded-full bg-[#525AFF] opacity-30 blur-[60px]" data-id="element-175" data-mp="2an4f232fclyz" />
              <div className="relative" data-id="element-176" data-mp="21mppusmcamq7">
                <p className="font-hero text-[56px] font-semibold leading-none tracking-[-0.02em] text-[#E4E4FF] sm:text-[60px]" data-id="element-177" data-mp="21lwqicppmzi3">
                  +2H
                </p>
                <p className="mt-5 font-hero text-[19px] font-medium leading-snug text-white/90" data-id="element-178" data-mp="1rvbumx1f892v">
                  {r.timeLabel[0]}
                </p>
                <p className="mt-2 text-[14px] leading-[1.5] text-white/80" data-id="element-179" data-mp="1muxj350m2h03">{r.timeLabel[1]}</p>
                <p className="mt-4 text-[11px] leading-[1.5] text-white/70" data-id="element-180" data-mp="1hwcl7c8u09et">{r.source}</p>
              </div>
            </article>

            <div className={`group relative isolate aspect-[4/5] overflow-hidden rounded-[14px] shadow-[0_18px_45px_rgba(8,8,82,0.10)] lg:aspect-auto lg:min-h-[280px] lg:flex-1 ${CARD_HOVER}`} data-id="element-181" data-mp="18wzakg8z1esi">
              <img src={PHOTO_PORTRAIT} alt={r.portraitAlt} loading="lazy" className={PHOTO_CLASS} data-id="element-182" data-mp="3piw2f89oteeo" />
            </div>
          </div>

          {/* Turnover */}
          <article className={`group flex h-full flex-col gap-7 rounded-[14px] bg-[#A5AEFF] p-2.5 shadow-[0_18px_45px_rgba(8,8,82,0.10)] sm:col-span-2 lg:col-span-1 ${CARD_HOVER}`} data-id="element-183" data-mp="2ezi9qosd3bz">
            <div className="relative isolate aspect-[4/3] overflow-hidden rounded-[10px] sm:aspect-[16/9] lg:aspect-auto lg:min-h-[340px] lg:flex-1" data-id="element-184" data-mp="35vonn9cmu702">
              <img src={PHOTO_DUO} alt={r.duoAlt} loading="lazy" className={PHOTO_CLASS} data-id="element-185" data-mp="3atq920xj6iep" />
            </div>
            <div className="px-4 pb-4" data-id="element-186" data-mp="3fn2nxjcerau9">
              <p className="font-hero text-[56px] font-semibold leading-none tracking-[-0.02em] text-blue-reways-950-lock sm:text-[60px]" data-id="element-187" data-mp="2i6x579ouh30h">
                −21 %
              </p>
              <p className="mt-4 font-hero text-[19px] font-medium text-blue-reways-950-lock" data-id="element-188" data-mp="3qge4destaqr8">{r.turnoverLabel}</p>
              <p className="mt-4 text-[11px] leading-[1.5] text-[rgba(8,8,82,0.7)]" data-id="element-189" data-mp="3lhj93ddnr9q8">{r.source}</p>
            </div>
          </article>
        </motion.div>

        <ul className="mt-12 flex flex-col items-center gap-4 text-center font-hero text-[18px] font-medium text-blue-reways-950-lock sm:mt-14 md:flex-row md:justify-between md:gap-6 md:text-[20px]" data-id="element-190" data-mp="32ihyj3z8hpr">
          {r.highlights.map((item, i) => <li key={item} className="flex items-center gap-6 md:flex-1 md:justify-center" data-id="element-191" data-mp="32iynu1yg6yki" data-mpi={i}>
              {i > 0 && <span aria-hidden="true" className="hidden h-6 w-px bg-[rgba(8,8,82,0.25)] md:block md:-ml-6" data-id="element-192" data-mp="3gj9f363o6f67" />}
              <span className="md:flex-1" data-id="element-193" data-mp="3bhsg5g4qx2s9">{item}</span>
            </li>)}
        </ul>
      </div>
    </section>;
}